import type { Chain } from '@/utils/types/index'

import * as all from './master'
import { base } from 'viem/chains'

export * from "./supportedChains"

export const DEFAULT_CHAIN_ID = base.id



export const sortChains = (chains) =>
  Object.values(chains).sort((a, b) => b.priorityRank - a.priorityRank)

export const CHAINS_ARR = Object.values(all).sort(
  (a, b) => b.priorityRank - a.priorityRank
)

const getChainEnumById = () => {
  const outObj = {}
  CHAINS_ARR.map((chain) => {
    outObj[chain.id] = chain.codeName
  })
  return outObj
}

const getids = () => {
  const outObj = {}
  CHAINS_ARR.map((chain) => {
    outObj[chain.chainSymbol] = chain.id
  })
  return outObj
}
const getChainsByID = () => {
  const outObj = {}
  CHAINS_ARR.map((chain) => {
    outObj[chain.id] = chain
  })
  return outObj
}

const getChainsByName = () => {
  const outObj = {}
  CHAINS_ARR.map((chain) => {
    outObj[chain.name] = chain
  })
  return outObj
}

export const CHAIN_ENUM_BY_ID = getChainEnumById()
export const CHAIN_IDS = getids() // used to be ids
export const CHAINS_BY_ID = getChainsByID()
export const CHAINS_BY_NAME = getChainsByName()
export const ORDERED_CHAINS_BY_ID = CHAINS_ARR.map((chain) => String(chain.id))

export const PAUSED_FROM_CHAIN_IDS = []
export const PAUSED_TO_CHAIN_IDS = [all.DOGE.id]



export const ChainId = {
  ETH: 1,
  ROPSTEN: 3,
  RINKEBY: 4,
  GÖRLI: 5,
  OPTIMISM: 10,
  CRONOS: 25,
  KOVAN: 42,
  BSC: 56,
  POLYGON: 137,
  FANTOM: 250,
  BOBA: 288,
  METIS: 1088,
  MOONBEAM: 1284,
  MOONRIVER: 1285,
  DOGECHAIN: 2000,
  CANTO: 7700,
  KLAYTN: 8217,
  HARDHAT: 31337,
  ARBITRUM: 42161,
  BASE: 8453,
  BLAST: 81457,
  AVALANCHE: 43114,
  DFK: 53935,
  AURORA: 1313161554,
  HARMONY: 1666600000,
}

export const AcceptedChainId = Object.fromEntries(
  Object.entries(ChainId).map(([key, value]) => [value, key])
)
